module.exports = __webpack_public_path__ + "media/images/respect-fd4a29713fc23bf480e351202f597ac5.svg";